import "core-js/modules/es.array.reverse.js";
var _dec, _dec2, _class, _class2, _SatelliteGuide;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { Component } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import Guide from "./Guide.jsx";
import satelliteGuideData from "./satelliteGuideData.js";
import { action, makeObservable } from "mobx";
import { observer } from "mobx-react";
import { jsx as _jsx } from "react/jsx-runtime";
export const SATELLITE_GUIDE_KEY = "satelliteGuidance";
let SatelliteGuide = (_dec = action.bound, _dec2 = action.bound, observer(_class = (_class2 = (_SatelliteGuide = class SatelliteGuide extends Component {
  constructor(props) {
    super(props);
    makeObservable(this);
  }
  handleMakeTopElement() {
    this.props.viewState.topElement = "Guide";
  }
  setShowSatelliteGuidance(bool) {
    this.props.viewState.showSatelliteGuidance = bool;
  }
  render() {
    const {
      terria,
      viewState,
      t
    } = this.props;
    const guideData = satelliteGuideData(t);
    return /*#__PURE__*/_jsx(Guide, {
      terria: terria,
      guideKey: SATELLITE_GUIDE_KEY,
      guideData: guideData,
      setShowGuide: bool => {
        this.setShowSatelliteGuidance(bool);
        // If we're closing for any reason, set prompted to true
        if (!bool) {
          viewState.toggleFeaturePrompt("satelliteGuidance", true, true);
        }
      }
    });
  }
}, _defineProperty(_SatelliteGuide, "propTypes", {
  terria: PropTypes.object.isRequired,
  viewState: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
}), _SatelliteGuide), _applyDecoratedDescriptor(_class2.prototype, "handleMakeTopElement", [_dec], Object.getOwnPropertyDescriptor(_class2.prototype, "handleMakeTopElement"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setShowSatelliteGuidance", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "setShowSatelliteGuidance"), _class2.prototype), _class2)) || _class);
export default withTranslation()(SatelliteGuide);